export const  colors = [
    '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', 
    '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf', 
    '#393b79', '#637939', '#8c6d31', '#843c39', '#7b4173', 
    '#5254a3', '#637939', '#8c6d31', '#8c6d31', '#7b4173', 
    '#393b79', '#5254a3', '#d6616b', '#e6550d', '#f7f7f7', 
    '#6b6ecf', '#b5cf6b', '#c7c7c7', '#c49c94', '#9c9ede', 
    '#cedb9c', '#3182bd', '#e6550d', '#31a354', '#7b4173', 
    '#6baed6', '#9ecae1', '#c6dbef', '#deebf7', '#3182bd', 
    '#6baed6', '#9ecae1', '#c6dbef', '#deebf7', '#3182bd', 
    '#9ecae1', '#c6dbef', '#deebf7', '#3182bd', '#9ecae1'
];
